import { BaseModel } from '@shared/models/entity/base/base.model';

export type DriveImportStatus = 'Pending' | 'Running' | 'Completed' | 'Failed' | 'Cancelled';

interface IDriveImport {
  name: string;

  rootFolderName: string;

  isDryRun: boolean;

  status: DriveImportStatus;

  importedCount: number;

  skippedCount: number;

  failedCount: number;

  importedBytes: number;

  startedAt: string;

  completedAt: string;

  lastError: string;
}

export class DriveImport extends BaseModel implements IDriveImport {
  name: string;

  rootFolderName: string;

  isDryRun: boolean;

  status: DriveImportStatus;

  importedCount: number;

  skippedCount: number;

  failedCount: number;

  importedBytes: number;

  startedAt: string;

  completedAt: string;

  lastError: string;

  constructor(init?: Partial<DriveImport>) {
    super(init);
    this.status ??= 'Pending';
  }
}